import { Card, CardBody, Col, Table } from "reactstrap";
import { OrdersByCountriesTitle } from "../../../../Constants/Constants";
import DashboardCommonHeader from "../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import { OrdersByCountriesData } from "../../../../Data/General/Dashboard/Ecommerce";
import { Link } from "react-router-dom";
import { H6 } from "../../../../AbstractElements";

const OrdersByCountries = () => {
  return (
    <Col xxl="4" lg="7" md="8" className="custom-order-1 box-col-7">
      <Card>
        <DashboardCommonHeader title={OrdersByCountriesTitle} dropdownClass="dropdown-toggle" />
        <CardBody className="sales-countries">
          <div className="table-responsive custom-scrollbar">
            <Table className="display">
              <tbody>
                {OrdersByCountriesData.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <div className="d-flex align-items-center gap-3">
                        <div className="flex-shrink-0">
                          <span>{item.countryCode}</span>
                        </div>
                        <div className="flex-grow-1">
                          <Link to={`${process.env.PUBLIC_URL}/applications/ecommerce/product`}>
                            <H6>{item.productName}</H6>
                          </Link>
                          <span>{item.location} </span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <span className={`font-${item.color} f-w-500`}>{item.growthRate}{item.growthDirection}</span>
                    </td>
                    <td>{item.date}</td>
                    <td>
                      <H6>{item.sales}</H6>
                      <span>Sales</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default OrdersByCountries;
